import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/wx_qrcode.jpg")